import { createSelector } from 'reselect';
import RfidUploadedFilesListColumns from '../../containers/RfidUploadedFilesListColumns';
import TableDefinitions from '../../../../common/TableDefinitions';

export const getIsLoading = (state) => state.listing.RFID_UPLOADED_FILES_LIST.isLoading;
export const getCheckedRows = (state) => state.listing.RFID_UPLOADED_FILES_LIST.selectedRows;
export const getData = TableDefinitions.RFID_UPLOADED_FILES_LIST.getDataFunction();
export const getColumns = createSelector(getData, RfidUploadedFilesListColumns);
